var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("CargoMsg.Cargo_InvoiceChargeUnitSetup"),
            width: "520px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            top: "5vh",
            "custom-class": "invoice-charge-unit-popup"
          },
          on: { open: _vm.showDialog }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-top": "0" }
            },
            [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "toAdd" },
                      on: { click: _vm.toAdd }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "toEdit",
                        disabled: _vm.isEditing
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        no: "toDelete",
                        disabled: _vm.isEditing
                      },
                      on: { click: _vm.toDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: {
                height: "360px",
                "padding-left": "10px",
                "padding-right": "6px"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", flex: "1" },
                attrs: {
                  "show-side-bar": false,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { height: "25px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "0",
                    "padding-right": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "toSave",
                        disabled: !_vm.needSave
                      },
                      on: { click: _vm.toSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "65px", "margin-left": "5px" },
                      attrs: { no: "cancel" },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }